import { useFlag } from '@b-stock/fe-core/bstock-next/helpers'

import { FeatureFlags } from '@/helpers/featureFlags'
import type { WatchlistStatus } from '@/queries/watchlistQuery'

/**
 * Whether a listing card shows its note icon: always for a watched listing,
 * and, while NOTES_OUTLIVE_WATCHLIST is on, for an un-watched listing that
 * has an active note.
 */
export const useShowsCardNote = (
  watchlistStatus: WatchlistStatus | undefined
): boolean => {
  const notesOutliveWatchlist = useFlag(FeatureFlags.NOTES_OUTLIVE_WATCHLIST)
  if (!watchlistStatus) return false
  if (watchlistStatus.isWatchlisted) return true
  return notesOutliveWatchlist && !!watchlistStatus.note
}
